import {SvgIconProps} from '@mui/material/SvgIcon';

function createMap(reqSVGs: __WebpackModuleApi.RequireContext) {
  return reqSVGs.keys().reduce((images, path) => {
    const result = images;
    const key = path.substring(path.indexOf('/') + 1, path.lastIndexOf('.'));
    result[key] = reqSVGs(path).default;
    return result;
  }, {});
}

const regularSvgMap = createMap(
  require.context('src/assets/icons/', false, /\.svg$/)
);

export function getIconComponentByName(
  name: string
): ((props: SvgIconProps) => JSX.Element) | undefined {
  // return find(Icons, (icon) => icon.name === name);
  return regularSvgMap[name];
}
